import Autosuggest from './Autosuggest';

export type { AutosuggestProps, Option } from './Autosuggest';
export default Autosuggest;
